export function getCurrentRawZoom(state) {
  return state.jigsaw.zoom;
}
